import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

const ContactSection = () => {
  return (
    <section className=" py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Left Side: Contact Cards */}
        <div className="space-y-6">
          {/* Phone Card */}
          <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
            <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
            <div className="relative z-10 flex items-center space-x-4">
              <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="text-gray-700 group-hover:text-red-500"
                />
              </div>
              <div>
                <p className="text-gray-600 group-hover:text-white">
                  Call Anytime
                </p>
                <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                  +91 7566611125
                </p>
              </div>
            </div>
          </div>

          {/* Email Card */}
         <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
                      <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
                      <div className="relative z-10 flex items-center space-x-4">
                        <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500">
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            className="text-gray-700 group-hover:text-red-500"
                          />
                        </div>
                        <div>
                          <p className="text-gray-600 group-hover:text-white">
                            Write Email
                          </p>
                          <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                            kalkacapital@gmail.com
                          </p>
                        </div>
                      </div>
                    </div>
        
          {/* Email Card */}
         <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
                      <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
                      <div className="relative z-10 flex items-center space-x-4">
                        <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500">
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            className="text-gray-700 group-hover:text-red-500"
                          />
                        </div>
                        <div>
                          <p className="text-gray-600 group-hover:text-white">
                            Write Email
                          </p>
                          <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                            info@kalkacapital.in
                          </p>
                        </div>
                      </div>
                    </div>
        
          {/* Location Card */}
          <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
            <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
            <div className="relative z-10 flex items-center space-x-4">
              <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500 ">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="text-gray-700 group-hover:text-red-500 "
                />
              </div>
              <div>
                <p className="text-gray-600 group-hover:text-white">
                  Office Location
                </p>
                <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                  Bhopal, India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Map */}
        <div className="relative">
          <div
            style={{
              position: "relative",
              textAlign: "right",
              width: "100%",
              height: "400px",
            }}
          >
            <div
              style={{
                overflow: "hidden",
                background: "none!important",
                width: "100%",
                height: "400px",
              }}
            >
              <iframe
                title="Google Map"
                width="100%"
                height="400"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src="https://maps.google.com/maps?width=1000&amp;height=400&amp;hl=en&amp;q=Kalka Capital Private Limited&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                style={{ height: "400px", border: "none" }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
